import { useContext } from "react"
import { OnboardingContext } from "../contexts/OnboardingContext"

const useOnboardingContext = () => useContext(OnboardingContext)

export default useOnboardingContext
